export const Spacing = {
  '4': 4,
  '6': 6,
  '8': 8,
  '10.5': 10.5,
  '12': 12,
  '14.5': 14.5,
  '16': 16,
  '18': 18,
  '20': 20,
  '24': 24,
  '32': 32,
  '48': 48,
  '64': 64
} as const

export type DSSpacing = keyof typeof Spacing
